module.exports = __webpack_public_path__ + "static/media/icon-entrega.6b887408.svg";